module.exports = __webpack_public_path__ + "img/icon-copy-id-usa.40d6ed6e.svg";